<template>
  <div class="orderDetailsBox">
    <!-- 进度条box -->
    <div class="progressBox" v-if="orderData.status >= 0">
      <el-steps :active="active" align-center style="width: 1100px">
        <el-step title="提交订单"><i class="iconfont" slot="icon">&#xe633;</i>
          <div slot="description" class="slotTime" v-if="orderData.createTime">
            <span>{{ orderData.createTime.split(" ")[0] }}</span>
            <span>{{ orderData.createTime.split(" ")[1] }}</span>
          </div>
        </el-step>
        <el-step :title="!isPay ? '等待确认收货后上传付款凭证' : '凭证上传成功'" class="noPadding"><i class="iconfont" slot="icon">&#xe610;</i>

          <el-upload v-if="!isPay" slot="description" class="upload-demo" :action="baseURL + uploadUrl" :data="{
              peopleId:
                $route.query.peopleId || JSON.parse($cookies.get('peopleId')),
              orderId: $route.query.id,
            }" accept=".jpg,.gif,.png" :on-success="uploadSuccess" :limit="1" :file-list="fileList" :show-file-list="false">
            <el-button type="primary" class="slotBtn">上传</el-button>
          </el-upload>
          <el-link slot="description" v-else type="primary" style="
              font-size: 12px;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            " :underline="false" @click="(imgShow = true), stopMove()">
            （点击查看大图）
          </el-link>
          <el-link class="accountInfoText" slot="description" @click="dialogVisible2 = true" :underline="false">收款账户信息<img src="/static/image/accountInfo.png" style="width: 15px; height: 15px; margin-left: 3px" /></el-link>
          <!-- <div slot="description" class="redText">
            财政预算单位信用额度内的订单，<br />平台采用先货后款的履约方式，<br />超出额度的交易，需先完成开票付款，<br />上传凭证后再行发货
          </div> -->
        </el-step>
        <el-step :title="active < 3 ? '等待订单确认' : '订单已确认'"><i class="iconfont" slot="icon">&#xe60f;</i>
          <div slot="description" class="slotTime" v-if="orderData.sendTime">
            <span>{{ orderData.sendTime.split(" ")[0] }}</span>
            <span>{{ orderData.sendTime.split(" ")[1] }}</span>
          </div>
        </el-step>
        <el-step title="等待收货"><i class="iconfont" slot="icon">&#xe6ec;</i></el-step>
        <el-step title="完成"><i class="iconfont" slot="icon">&#xe687;</i>
          <div slot="description" class="slotTime" v-if="orderData.finishTime">
            <span>{{ orderData.finishTime.split(" ")[0] }}</span>
            <span>{{ orderData.finishTime.split(" ")[1] }}</span>
          </div>
        </el-step>
      </el-steps>
    </div>
    <!-- 收货人信息，付款信息box -->
    <div class="orderInfoBox">
      <div class="orderInfoBox_list">
        <div class="orderInfoBox_listTitle">收货人信息</div>
        <div class="orderInfoBox_listBody">
          <div class="listBody_label">收货人：</div>
          <div class="listBody_text">{{ orderData.pickerName }}</div>
        </div>
        <div class="orderInfoBox_listBody">
          <div class="listBody_label">收货地址：</div>
          <div class="listBody_text">
            {{ orderData.regionInfo + orderData.detailInfo }}
          </div>
        </div>
        <div class="orderInfoBox_listBody">
          <div class="listBody_label">手机号码：</div>
          <div class="listBody_text">{{ orderData.pickerMobile }}</div>
        </div>
      </div>
      <div class="orderInfoBox_list" v-if="isPay" style="border-left: 1px solid #dddddd">
        <div class="orderInfoBox_listTitle">付款信息</div>
        <div class="orderInfoBox_listBody">
          <div class="listBody_label">付款方式：</div>
          <div class="listBody_text">上传付款凭证</div>
        </div>
        <div class="orderInfoBox_listBody">
          <div class="listBody_label">付款时间：</div>
          <div class="listBody_text">
            {{ orderData.payTime }}
          </div>
        </div>
      </div>
      <el-button class="printBtn" type="primary" @click="printOrder()" size="small" v-if="orderData.status>=1">
        订单打印</el-button>
    </div>
    <!-- 商品信息box -->
    <div class="goodsInfoBox">
      <!-- 表头 -->
      <div class="goodsInfoBox_head">
        <span style="width: 340px">商品名称</span>
        <span style="width: 224px">商品编号</span>
        <span style="width: 198px">单价</span>
        <span style="width: 170px">数量</span>
        <span style="width: 218px">操作</span>
      </div>
      <!-- 商品列表 -->
      <div class="goodsInfoBox_list" v-for="(item, index) in orderData.goodsItems" :key="index">
        <div style="width: 340px; display: flex">
          <img :src="item.goodsThumb" alt="" style="width: 60px; height: 60px" />
          <div class="goodsInfoBox_listName">
            <div>{{ item.title }}</div>
            <!-- <span class="goodsInfoBox_listTag">麻辣</span> -->
          </div>
        </div>
        <div style="width: 224px">{{ item.goodsId }}</div>
        <div style="width: 198px; color: #ff4019; font-size: 14px">
          ￥{{ item.price.toFixed(2) }}
        </div>
        <div style="width: 170px">{{ item.total }}件</div>
        <div class="btnBox">
          <el-link v-if="active > 3" :underline="false" type="primary" style="font-size: 12px" @click="getExpress(item)">查看物流</el-link>
          <el-link v-if="active > 4" :underline="false" type="primary" style="font-size: 12px; margin-left: 15px" @click="showmsg()">申请售后</el-link>
        </div>
      </div>
      <!-- 底部价格 -->
      <div class="goodsInfoBox_foot">
        <div class="goodsInfoBox_footLInfo">
          <div class="goodsInfoBox_footImageBox">
            <img style="margin: 0 46px 0 12px" src="static/image/jszfLogo.png" alt="" />
            <img src="static/image/newLogo.png" alt="" />
          </div>
          <span class="goodsInfoBox_footText1">订单来源：江苏政府采购网 — 鲜丰汇消费帮促平台</span>
          <span class="goodsInfoBox_footText2">江苏政府采购网上商城
            <a href="http://www.ccgp-jiangsu.gov.cn/jiangsu/wssc" target="_blank">http://www.ccgp-jiangsu.gov.cn/jiangsu/wssc</a></span>
        </div>
        <div class="goodsInfoBox_footL">
          <span>商品总额：</span>
          <span>配送费：</span>
          <span style="color: #ff4019; margin-top: 10px">{{
            isPay ? "实付款：" : "需付款："
          }}</span>
        </div>
        <div class="goodsInfoBox_footR">
          <span>￥{{
              orderData.goodsPrice ? orderData.goodsPrice.toFixed(2) : "0.00"
            }}</span>
          <span>￥0.00</span>
          <span style="
              color: #ff4019;
              margin-top: 10px;
              font-size: 14px;
              font-family: Microsoft YaHei, Microsoft YaHei-Bold;
              font-weight: 700;
            ">￥{{ orderData.price ? orderData.price.toFixed(2) : "0.00" }}</span>
        </div>
      </div>
    </div>
    <!-- 凭证大图弹窗 -->
    <div v-show="imgShow" class="imgDialog" @scroll.prevent @click="(imgShow = false), Move()">
      <img width="400px" height="400px" :src="imgUrl" alt="" style="cursor: pointer" />
    </div>
    <!-- 查看物流-物流信息弹窗 -->
    <el-dialog title="物流信息" :visible.sync="dialogVisible" :destroy-on-close="isTrue" width="60%" class="delivery_dialogBody">
      <img :src="expressGoodsData.goodsThumb" alt="" class="delivery_GoodsImg">
      <div class="delivery_mainBox">
        <div class="delivery_goodsBox">
          <div class="delivery_goodsTitle">{{expressGoodsData.title}}</div>
          <div class="delivery_goodsId">商品编号：{{expressGoodsData.goodsId}}</div>
        </div>
        <div class="deliveryList" v-for="(item,index) in expressData" :key="index">
          <span class="deliveryList_time">{{item.sendTime}}</span>
          <div class="deliveryList_info">
            <span class="deliveryList_infoLabel">
              <span class="iconfont">&#xe67c;</span>
              物流公司：
            </span>
            <span class="deliveryList_infoValue">{{item.expressCompany}}</span>
            <div class="deliveryList_infoLine"></div>
            <span class="deliveryList_infoLabel">
              <span class="iconfont">&#xe6b1;</span>
              快递单号：
            </span>
            <span class="deliveryList_infoValue" id="expressNum">{{item.expressNumber}}</span>
            <span class="copyBtn" data-clipboard-target="#expressNum" @click="copyNum('.copyBtn')">复制</span>
          </div>
          <div class="deliveryList_remark">
            <span class="deliveryList_infoLabel">
              发货备注：
            </span>
            <span class="deliveryList_infoValue">{{item.remark}}</span>
          </div>
        </div>
        <!-- <div class="deliveryBox">
          <span class="deliveryBox_list">配送方式：<span style="color: #333">{{
            expressData.expName || expressData.expressCompany
          }}</span></span><span class="deliveryBox_list">快递单号：<span style="color: #333">{{
            expressData.number
          }}</span></span>
        </div>
        <div class="deliveryBox" v-if="!expressData.list">
          <span class="deliveryBox_list">备注信息：<span style="color: #333">{{
            expressData.remark
          }}</span></span>
        </div>
        <div class="timeLineBox" v-else>
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in expressData.list" :key="index" :timestamp="activity.time">
              <span class="timeLineBox_tip"> {{ activity.status }}</span>
            </el-timeline-item>
          </el-timeline>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 收款账户信息弹窗 -->
    <el-dialog title="收款账户信息" :visible.sync="dialogVisible2" width="767px">
      <div class="proofPayBox_infoText" style="margin-top: 18px">
        收款账号：<span style="font-size: 18px" id="userNum">{{
          accountInfo.bankAccount
        }}</span><span class="copyTrackingNumber" style="
            font-size: 12px;
            color: #f89a00;
            margin-left: 10px;
            cursor: pointer;
          " data-clipboard-target="#userNum" @click="copyNum('.copyTrackingNumber')">复制20位账号</span>
      </div>
      <div class="proofPayBox_infoText">
        收款公司名：{{ accountInfo.bankCompany }}
      </div>
      <div class="proofPayBox_infoText">开户行联行号：310301000215</div>
      <div class="proofPayBox_infoText">
        开户行名称：{{ accountInfo.bankAddress }}
      </div>
      <div class="proofPayBox_infoText">
        备注信息：<span style="color: red; font-size: 12px">为便于财务核款，付款备注信息需加上：单位名称+鲜丰汇+登录账号（可选）</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { doGet, doGetBlob, baseURL } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
import Clipboard from "clipboard";
import download from "downloadjs";
export default {
  data() {
    return {
      orderData: "", //订单信息
      active: 0, //进度条index（当前在第几步）
      isTrue: true, //物流信息弹窗关闭后销毁
      uploadUrl: httpConfig.proofPay.uploadProof, //上传文件接口
      baseURL,
      fileList: [], //上传文件列表
      imgShow: false, //凭证大图弹窗是否显示
      imgUrl: "", //凭证大图地址
      dialogVisible: false, //物流信息弹窗是否显示
      dialogVisible2: false, //收款账户信息弹窗是否显示
      expressData: "", //物流信息
      expressGoodsData: "", //物流商品信息
      isPay: false,
      accountInfo: "",
    };
  },
  mounted() {
    this.getData(this.$route.query.id); //获取订单信息
  },
  methods: {
    //拷贝快递单号
    copyNum(className) {
      // 括号中的内容：对应复制按钮的class
      let clipboard = new Clipboard(className);
      let that = this;
      clipboard.on("success", function (e) {
        that.$message({
          message: "复制成功",
          type: "success",
        });
        clipboard.destroy();
      });
      clipboard.on("error", function (e) {
        that.$message({
          message: "复制失败",
          type: "error",
        });
        clipboard.destroy();
      });
    },
    /**
     * 停止页面滚动
     */
    stopMove() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); //禁止页面滑动
    },
    /**
     * 开启页面滚动
     */
    Move() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
    /**
     * 获取订单信息
     */
    getData(id) {
      var that = this;
      var data = {
        peopleId: this.$route.query.peopleId
          ? this.$route.query.peopleId
          : JSON.parse(this.$cookies.get("peopleId")),
        orderId: id,
      };
      doGet(
        httpConfig.orderDetails.getDataUrl,
        data,
        function (res) {
          if (res.flag) {
            that.orderData = JSON.parse(JSON.stringify(res.data));
            that.imgUrl = that.orderData.verifycode;

            that.isPay = that.orderData.verifycode !== "";
            that.active = that.orderData.status + 2;
          }
        },
        function (res) {}
      );
      var that = this;
      doGet(
        httpConfig.proofPay.getInfoUrl,
        {
          orderId: id,
          peopleId: this.$route.query.peopleId
            ? this.$route.query.peopleId
            : JSON.parse(this.$cookies.get("peopleId")),
        },
        function (res) {
          if (res.flag) {
            that.accountInfo = res.data;
          } else {
            that.$message({
              type: "error",
              message: res.message,
            });
          }
        },
        function (res) {}
      );
    },
    /**
     * 上传凭证成功后的回调
     */
    uploadSuccess(res, file, fileList) {
      if (res.flag) {
        this.$message.success("上传成功");
        this.getData(this.$route.query.id);
      } else {
        this.$message.error(res.message);
      }
    },
    /**
     * 获取物流信息
     */
    getExpress(item) {
      var that = this;
      doGet(
        httpConfig.orderDetails.getLogisticsUrl,
        {
          ordersn: that.orderData.ordersn,
          sku: item.sku,
        },
        function (res) {
          if (res.flag) {
            if (res.data.length > 0) {
              that.expressData = res.data;
              that.expressGoodsData = item;
              that.dialogVisible = true;
            } else {
              that.$message.warning("未查询到快递信息！");
            }
          } else {
            that.$message.error(res.message || "网络异常");
          }
        },
        function (res) {}
      );
    },
    showmsg() {
      this.$alert("请联系区域客服经理处理售后", "提示", {
        confirmButtonText: "确定",
        callback: (action) => {},
      });
    },
    /**
     * 打印订单
     */
    printOrder() {
      doGetBlob(
        httpConfig.orderDetails.exportOrderPdfUrl,
        {
          peopleId: this.$route.query.peopleId
            ? this.$route.query.peopleId
            : JSON.parse(this.$cookies.get("peopleId")),
          orderId: this.$route.query.id,
        },
        function (res) {
          download(
            new Blob([res], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
            }),
            "鲜丰汇消费帮促平台订单明细" +
              new Date().getFullYear() +
              "-" +
              (new Date().getMonth() + 1 < 10
                ? "0" + (new Date().getMonth() + 1) + "-"
                : new Date().getMonth() + 1 + "-") +
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate()) +
              ".pdf",
            "application/pdf"
          );
        },
        function (res) {}
      );
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/orderDetails";
</style>



// WEBPACK FOOTER //
// src/components/page/orderDetails.vue